<template>
  <div class="w-full rounded px-2 pt-2 pb-8 mb-6">
    <el-row :gutter="20">
      <el-col :span="24" class="mb-6">
        <el-button icon="el-icon-back" size="small"
                   @click="$router.push('/ecommerce/orders')">Back to list</el-button>
        <el-button type="danger" icon="el-icon-delete" size="small" class="float-right" plain
                   @click="deleteOrder(updateForm.id)">Delete</el-button>
        <el-button type="info" icon="el-icon-error" size="small" class="float-right"
                   @click="$router.back()">Cancel</el-button>
      </el-col>
    </el-row><hr><br>
    <el-form :model="updateForm" :label-position="labelPosition" :rules="rules" ref="updateForm">
      <el-steps :active="active" simple finish-status="success">
        <el-step title="Items" icon="el-icon-s-goods"></el-step>
        <el-step title="Order Details" icon="el-icon-s-order"></el-step>
        <el-step v-if="updateForm.delivery_option_id === 1" title="Delivery" icon="el-icon-location"></el-step>
      </el-steps>
      <div v-if="active === 0">
        <el-row :gutter="20" class="px-5 pt-3">
          <el-button class="float-right" @click="next"><i class="el-icon-arrow-right"></i>
          </el-button>
        </el-row>
        <div class="px-2">
          <el-row class="items col-hd py-2">
            <el-col :span="12" class="pt-2 pb-2 px-2">Item</el-col>
            <el-col :span="4" class="pt-2 pb-2 px-2">Qty</el-col>
            <el-col :span="4" class="pt-2 pb-2 px-2">Unit Price</el-col>
            <el-col :span="4" class="pt-2 pb-2 px-2">
              <el-button size="mini" type="info" icon="el-icon-plus-outline"
               @click="$modal.show('new-ordered-item-modal')">
                Add Item
              </el-button>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="items px-2 py-2"
                  v-for="oItem of updateForm.orderedItems" v-bind:key="oItem.id">
            <el-col :span="12" class="col-item">
              <span v-if="editMode === true && oItem.id === orderedItemInEditMode">
                <el-select v-model="selectedItemId" filterable size="mini">
                  <el-option
                    v-for="item of items"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </span>
              <span v-else>{{oItem.item_name}}</span>
            </el-col>
            <el-col :span="4" class="col-item">
              <span v-if="editMode === true && oItem.id === orderedItemInEditMode">
                <el-input v-model="selectedItemQty" type="number" size="mini"></el-input>
              </span>
              <span v-else>{{ oItem.quantity }}</span>
            </el-col>
            <el-col :span="4" class="col-item">
              {{ priceFormat(Number(oItem.item_price).toFixed(2)) }}
            </el-col>
            <el-col :span="4" class="col-item">
              <span v-if="editMode === true && oItem.id === orderedItemInEditMode">
                <el-button @click="updateItem(oItem.id)" size="mini" icon="el-icon-success"
                           type="text" class="text-green-500">Update</el-button>
                <el-button size="mini" icon="el-icon-error" type="text" class="text-red-500"
                           @click="closeEdit()">Cancel</el-button>
              </span>
              <span v-else>
                <el-button @click="editItem(oItem.id, oItem, oItem.quantity)" type="text"
                           icon="el-icon-edit-outline" size="mini">Edit</el-button>
                <el-button @click="deleteItem(oItem.id)" type="text" icon="el-icon-delete-solid"
                           size="mini" class="text-red-500">Remove</el-button>
              </span>
            </el-col>
          </el-row>
        </div>
      </div>
      <div v-if="active === 1">
        <el-row :gutter="20" class="px-5 pt-3">
          <el-button icon="el-icon-arrow-left" @click="previous"></el-button>
          <el-button class="float-right" @click="next"><i class="el-icon-arrow-right"></i>
          </el-button>
        </el-row>
        <div class="px-2">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12">
              <el-form-item prop="user_id">
                <label class="text-sm block">Customer:</label>
                <el-select class="w-full" v-model="updateForm.user_id" filterable placeholder="Please select...">
                  <el-option
                    v-for="cus in customers"
                    :key="cus.id"
                    :label="cus.email"
                    :value="cus.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item prop="status_id">
                <label class="text-sm block">Order status:</label>
                <el-select class="w-full" v-model="updateForm.status_id" filterable placeholder="Please select...">
                  <el-option
                    v-for="status in statuses"
                    :key="status.id"
                    :label="status.name"
                    :value="status.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12">
              <el-form-item prop="outlet_id">
                <label class="text-sm block">Processing outlet:</label>
                <el-select class="w-full" v-model="updateForm.outlet_id" filterable placeholder="Please select...">
                  <el-option
                    v-for="outlet in outlets"
                    :key="outlet.id"
                    :label="outlet.name"
                    :value="outlet.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item prop="pickup_outlet_id">
                <label class="text-sm block">Pickup outlet:</label>
                <el-select class="w-full" v-model="updateForm.pickup_outlet_id" filterable placeholder="Please select...">
                  <el-option
                    v-for="outlet in outlets"
                    :key="outlet.id"
                    :label="outlet.name"
                    :value="outlet.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12">
              <el-form-item prop="delivery_method_id">
                <label class="text-sm block">Delivery method:</label>
                <el-select class="w-full" v-model="updateForm.delivery_method_id" filterable placeholder="Please select...">
                  <el-option
                    v-for="outlet in delivery_methods"
                    :key="outlet.id"
                    :label="outlet.name"
                    :value="outlet.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item prop="est_delivery_time">
                <label class="text-sm block">Est. delivery time</label>
                <el-date-picker
                  class="w-full"
                  v-model="updateForm.est_delivery_time"
                  type="datetime"
                  placeholder="Select date and time">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24">
              <el-form-item prop="admin_comments">
                <label class="text-sm block">Admin comment:</label>
                <el-input type="textarea" :rows="2" class="w-full"
                          v-model="updateForm.admin_comments"
                          placeholder="Enter your comment here">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="mb-4">
            <el-form-item prop="status">
              <el-col :xs="24">
                <label class="text-sm block">Delivered</label>
                <el-switch v-model="updateForm.delivered"></el-switch>
              </el-col>
            </el-form-item>
          </el-row>
        </div>
        <el-row :gutter="20" class="px-3" v-if="updateForm.delivery_option_id !== 1">
          <el-col :xs="24">
            <el-button type="primary" class="w-full"
                       @click="update('updateForm')"
                       :updating="updating">Update Order</el-button>
          </el-col>
        </el-row>
      </div>
      <div v-if="active === 2 && updateForm.delivery_option_id === 1">
        <el-row :gutter="20" class="px-5 pt-3">
          <el-button icon="el-icon-arrow-left" @click="previous"></el-button>
          <el-button class="float-right" @click="next"><i class="el-icon-arrow-right"></i>
          </el-button>
        </el-row>
        <div class="px-2">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12">
              <el-form-item prop="delivery_first_name">
                <label class="text-sm block">First name</label>
                <el-input class="w-full" type="text"
                          v-if="updateForm.deliveryAddress"
                          v-model="updateForm.deliveryAddress.first_name">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item prop="delivery_last_name">
                <label class="text-sm block">Last name</label>
                <el-input class="w-full" type="text"
                          v-if="updateForm.deliveryAddress"
                          v-model="updateForm.deliveryAddress.last_name">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12">
              <el-form-item prop="delivery_phone">
                <label class="text-sm block">Phone</label>
                <el-input class="w-full" type="text"
                          v-if="updateForm.deliveryAddress"
                          v-model="updateForm.deliveryAddress.phone">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item prop="delivery_address">
                <label class="text-sm block">Address</label>
                <el-input class="w-full" type="text"
                          v-if="updateForm.deliveryAddress"
                          v-model="updateForm.deliveryAddress.address">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12">
              <el-form-item prop="delivery_zip_code">
                <label class="text-sm block">Zip/Postal Code</label>
                <el-input class="w-full" type="number"
                          v-if="updateForm.deliveryAddress"
                          v-model="updateForm.deliveryAddress.zip_code">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item prop="delivery_city">
                <label class="text-sm block">City</label>
                <el-input class="w-full" type="text"
                          v-if="updateForm.deliveryAddress"
                          v-model="updateForm.deliveryAddress.city">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12">
              <el-form-item prop="delivery_state">
                <label class="text-sm block">State</label>
                <el-input class="w-full" type="text"
                          v-if="updateForm.deliveryAddress"
                          v-model="updateForm.deliveryAddress.state">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item prop="delivery_country">
                <label class="text-sm block">Country</label>
                <el-input class="w-full" type="text"
                          v-if="updateForm.deliveryAddress"
                          v-model="updateForm.deliveryAddress.country">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row :gutter="20" class="px-3">
          <el-col :xs="24">
            <el-button type="primary" class="w-full"
                       @click="update('updateForm')"
                       :updating="updating">Update Order</el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <NewOrderItemForm :order="updateForm" />
  </div>
</template>

<script>

import NewOrderItemForm from './_includes/NewOrderItemForm.vue';

export default {
  name: 'UpdateOrder',
  components: {
    NewOrderItemForm,
  },
  data() {
    return {
      updating: false,
      labelPosition: 'top',
      activeName: 'general',
      active: 0,
      editMode: false,
      orderedItemInEditMode: '',
      selectedItemId: '',
      selectedItemQty: '',
      date_format: 'YYYY-MM-DD HH:mm',
      est_date: '2019-10-09',
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      rules: this.$store.state.OrderModule.validate_form,
    };
  },
  computed: {
    updateForm() {
      return this.$store.state.OrderModule.order;
    },
    customers() {
      return this.$store.state.CustomerModule.customers;
    },
    outlets() {
      return this.$store.state.OutletModule.outlets;
    },
    statuses() {
      return this.$store.state.SettingsModule.Statuses.statuses;
    },
    delivery_methods() {
      return this.$store.state.SettingsModule.DeliveryMethods.delivery_methods;
    },
    items() {
      return this.$store.state.InventoryModule.Products.products;
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    try {
      await this.$store.dispatch('OrderModule/getOrder', { orderId: this.$route.params.id });
      await this.$store.dispatch('CustomerModule/fetchAllCustomers', { page: null, limit: null });
      await this.$store.dispatch('SettingsModule/Statuses/fetchAllStatuses');
      await this.$store.dispatch('OutletModule/fetchAllOutlets');
      await this.$store.dispatch('SettingsModule/DeliveryMethods/fetchAllDeliveryMethods', { page: null, limit: null });
      await this.$store.dispatch('InventoryModule/Products/fetchPluckedProducts');
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
  methods: {
    update(updateForm) {
      const formData = {
        user_id: this.updateForm.user_id,
        status_id: this.updateForm.status_id,
        outlet_id: this.updateForm.outlet_id,
        pickup_outlet_id: this.updateForm.pickup_outlet_id,
        admin_comments: this.updateForm.admin_comments,
        delivery_schedule: this.updateForm.delivery_schedule,
        delivered: this.updateForm.delivered,
        delivery_method_id: this.updateForm.delivery_method_id,
        delivery_amount: this.updateForm.delivery_amount,
        est_delivery_time: this.updateForm.est_delivery_time,
        coupon_items: this.updateForm.coupon_items,
        deliveryAddress: {
          first_name: this.updateForm.deliveryAddress.first_name,
          last_name: this.updateForm.deliveryAddress.last_name,
          address: this.updateForm.deliveryAddress.address,
          phone: this.updateForm.deliveryAddress.phone,
          zip_code: this.updateForm.deliveryAddress.zip_code,
          city: this.updateForm.deliveryAddress.city,
          state: this.updateForm.deliveryAddress.state,
          country: this.updateForm.deliveryAddress.country,
        },
      };
      this.$refs[updateForm].validate(async (valid) => {
        if (valid) {
          try {
            this.updating = true;
            await this.$store.dispatch('OrderModule/updateOrder', {
              orderId: this.$route.params.id, order: formData,
            });
            await this.$router.push(`/ecommerce/orders/${this.$route.params.id}/details`);
            this.$notify.success({
              title: 'Success',
              message: 'Order update was successful.',
            });
          } catch (e) {
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong please try again.',
            });
          }
          this.updating = false;
        } else {
          return false;
        }
      });
    },
    deleteOrder(orderId) {
      this.$confirm('Are you sure you want to delete this order?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('OrderModule/deleteOrder', { orderId });
          this.$notify.success({
            title: 'Success',
            message: 'Order has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
    notBeforeToday(date) {
      return date < today;
    },
    editItem(orderedItem, item, qty) {
      this.editMode = true;
      this.orderedItemInEditMode = orderedItem;
      this.selectedItemId = item.item_id;
      this.selectedItemQty = qty;
    },
    async updateItem(id) {
      const item = this.items.filter(el => el.id === this.selectedItemId)[0];
      const formData = {
        item_id: this.selectedItemId,
        quantity: this.selectedItemQty,
        item_name: item.name,
        item_price: item.price,
        item_weight: item.weight,
        item_preview: item.image,
      };
      try {
        this.updating = true;
        await this.$store.dispatch('OrderModule/updateOrderItem',
          { orderedItemId: id, orderedItem: formData });
        this.$notify.success({
          title: 'Success',
          message: 'Order update was successful.',
        });
        this.closeEdit();
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
      this.updating = false;
    },
    closeEdit() {
      this.editMode = false;
      this.orderedItemInEditMode = '';
      this.selectedItemId = '';
      this.selectedItemQty = '';
    },
    deleteItem(id) {
      this.$confirm('Are you sure you want to delete this order item?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('OrderModule/deleteOrderItem', { orderId: id });
          this.$notify.success({
            title: 'Success',
            message: 'Order item has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
    next() {
      if (this.active++ > 2) this.active = 0;
    },
    previous() {
      if (this.active-- < 2) this.active = 0;
    },
    reset() {
      this.active = 0;
    },
  },
};
</script>

<style scoped lang="scss">
  .w-full {
    width: 100% !important;
    .mx-input { height: 40px !important; }
  }
  .col-hd {
    font-size: 15px;
    font-weight: 500;
    margin-top: 10px;
    background-color: #f9f9f9;
  }
  .items {
    color: #909399;
    .col-item {
      padding-bottom: 6px;
    }
  }
</style>
